import { FieldValidator } from "final-form";
import { useState } from "react";
import { FC, HTMLInputTypeAttribute, ChangeEvent } from "react";
import { Field } from "react-final-form";
import { TextField } from "@Components/ui";
import { IFieldSetter } from "context/checkout/CheckoutProvider";
import classes from "./FormTextField.module.scss";

interface Props {
  name: string;
  placeholder?: string;
  label?: string;
  type?: HTMLInputTypeAttribute;
  validate?: FieldValidator<string>;
  inputProps?: Object;
  outlined?: boolean;
  minLength?: number;
  maxLength?: number;
  showToolTip?: boolean;
  showTooltipIconOnErrorOnly?: boolean;
  toolTipData?: any;
  onChange?: IFieldSetter;
  value?: String;
  className?: string;
  withPreview?: boolean;
  onFocus?: any;
  onBlur?: any;
}

const FormTextField: FC<Props> = ({
  name = "",
  type = "text",
  outlined,
  validate,
  showToolTip,
  toolTipData,
  onChange,
  inputProps,
  withPreview,
  value,
  onFocus,
  onBlur,
  ...restProps
}) => {
  const classNames = [
    classes["form__field"],
    classes["text__field"],
    [restProps.className || ""],
  ]
    .join(" ")
    .trim();
  const tooltipIcon = type === "password" ? "lock" : undefined;

  const [touched, setTouched] = useState(false);

  return (
    <Field
      name={name}
      validate={validate}
      formatOnBlur
      type={type}
      format={(value) => value?.trim()}
    >
      {({ input, meta }) => (
        <div className={classNames}>
          <TextField
            {...restProps}
            {...input}
            {...inputProps}
            value={value || input.value || ""}
            onChange={(event: ChangeEvent<HTMLInputElement>) => {
              if (!touched) setTouched(true);
              input.onChange?.(event);
              if (onChange) {
                onChange(event);
              }
            }}
            withPreview={withPreview}
            tooltipData={toolTipData ?? (showToolTip && touched && meta.error)}
            tooltipIcon={showToolTip && tooltipIcon}
            className={`${outlined && classes.standard_outlined}`}
            validate={validate}
            touched={touched}
            supressErrorStylesOnFocus
            formTextFieldValidation
            onFocus={onFocus}
            onBlur={onBlur}
          />
        </div>
      )}
    </Field>
  );
};

FormTextField.defaultProps = {
  validate: undefined,
  outlined: false,
  showToolTip: true,
  withPreview: false,
};

export default FormTextField;
